






import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: 'BottomPartSwitcher'
})
export default class BottomPartSwitcher extends Vue {
    @Prop() totalNumber: number;
    @Prop() currentIndex: number;
    @Prop({default: false}) showBottomPart: boolean;
    @Prop({default: false}) readOnlyMode: boolean;

    get currentIndexToShow() {
        if (this.currentIndex != undefined) {
            return this.currentIndex + 1;
        }

        return 1;
    }
}
